import type { Meta, StoryObj } from "@storybook/react";

import type { SidewaysHighlightTextProps } from "@/ui/core";
import { SidewaysHighlightText } from "@/ui/core";
import { Box } from "@/ui/layout";

const StoryMeta: Meta<SidewaysHighlightTextProps> = {
  title: "Core/SidewaysHighlightText",
  component: SidewaysHighlightText,
  argTypes: {
    text: { control: "text" },
  },
  args: {
    text: "Placeholder",
  },
  render: (props) => (
    <Box padding={100}>
      <SidewaysHighlightText {...props} />
    </Box>
  ),
};

type Story = StoryObj<SidewaysHighlightTextProps>;

export const Primary: Story = {};
export default StoryMeta;
